import { Typography } from '@mui/material';
import classnames from 'classnames';
import LoadableMonacoEditor from 'js/components/elements/editors/monaco/LoadableMonacoEditor';
import React from 'react';
import classes from './TestCustomProcessor.module.scss';

interface Props {
  heading: string;
  subheading: string;
  result?: {
    statusCode: number;
    response?: string;
    errorMessage?: string;
  };
  isLoading: boolean;
  className?: string;
  editorHeight?: string;
  'data-testid'?: string;
}

export default function CodeSection({
  heading,
  subheading,
  result,
  isLoading,
  className = '',
  editorHeight = '100%',
  'data-testid': dataTestId,
}: Props) {
  const { response, errorMessage, statusCode } = result || {};
  const hasError = errorMessage || statusCode >= 400;
  let code: string;

  if (isLoading) {
    code = 'Loading...';
  } else if (hasError) {
    code = errorMessage;
  } else {
    code = response;
  }

  return (
    <div className={`${classes.section} ${className}`} data-testid={dataTestId}>
      <div
        className={classnames(classes.editorInfo, {
          [classes.error]: hasError,
        })}
      >
        <Typography variant="subheading2">{heading}</Typography>
        <div className="ellipsis" data-testid={`${dataTestId}-subheading`}>
          {subheading}
        </div>
      </div>
      <div className={classes.editorContainer}>
        <LoadableMonacoEditor
          theme="dark"
          height={editorHeight}
          options={{
            readOnly: true,
            minimap: { enabled: false },
            wordWrap: 'on',
          }}
          value={code || ''}
        />
      </div>
    </div>
  );
}
